/*
 * StreamBank Admin v38.0
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';

import {BaseComponent} from "../BaseComponent";
import {StreamBankLink} from "../Common/StreamBankLink";

export class Footer extends BaseComponent {
    render() {
        return (
            <Container className="streambank-footer">
                <hr />
                <Row>
                    <Col xs={12}>
                        Copyright &copy; 2017-Present, <StreamBankLink Href="https://www.thefreshwatertrust.org">The Freshwater Trust</StreamBankLink>, All Rights Reserved.
                    </Col>
                </Row>
            </Container>
        );
    }
}
